<div class="container my-4">
    <div class="row">
        <div class="col-12">
            <span class="title_header_bar ">Vumatel Network Events ({{head}})<mat-slide-toggle
                    class="custom-toggle ml-2" [(ngModel)]="future" (change)="toggleSwitch()">
                </mat-slide-toggle></span>
        </div>
    </div>

    <div class="row scale-in-hor-center">
        <div class="packages col-md-12 " >
            <div class="row packages-container" style="white-space: normal; height: auto; ">
                <ng-container *ngFor="let datas of data let i =index">
                    <div class="card1 col-xs-12 col-lg-4 col-md-6 col-sm-9 col-xl-4 mt-3">
                        <div>
                            <div class="package" style="height: auto;">
                                <div class="row" style="margin-top: -20px;">
                                    <div class="col-12 pt-3 ">
                                        <span style="font-size: 20px;"><b>Event ID {{datas.prefixed_id}}</b></span>
                                    </div>
                                </div>
                                <hr>

                                <div class="row">
                                    <div class=" col-6"
                                        style=" border-right: 1px solid;background-color: none !important;">
                                        <p class="per-month mb-1">Reason</p>
                                        <h6><b>{{datas.reason||'--'}}</b> </h6>
                                    </div>
                                    <div class="col-6" style="border-radius: 20px;">
                                        <p class="per-month mb-1">Impact</p>
                                        <h6>{{datas.impact||'--'}}</h6>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-1"></div>

                                    <div class="col-10" style="border-radius: 20px;">
                                        <p class="per-month mb-1   ">Status</p>
                                        <h6 class="status-text" [ngClass]="{'clickable': overflowStatuses[i]}"
                                            (click)="openDialog(datas.status,'status', i)" #statusText>
                                            {{datas.status}}</h6>
                                    </div>
                                    <div class="col-1"></div>

                                </div>
                                <hr>

                                <div class="row">
                                    <div class=" col-6"
                                        style=" border-right: 1px solid;background-color: none !important;">
                                        <p class="per-month">Grade : <span
                                                style="font-size: 16px;"><b>{{datas.grade||'--'}}</b></span></p>

                                        <hr>
                                        <p class="per-month">Priority : <span
                                                style="font-size: 16px;"><b>{{datas.priority||'--'}}</b></span></p>

                                    </div>
                                    <div class="col-6 mt-3" style="border-radius: 20px;">
                                        <p class="per-month pb-1">Urgency</p>
                                        <h6> {{datas.urgency|| '---'}}</h6>
                                    </div>
                                </div>
                                <hr>

                                <div class="row">

                                    <div class=" col-6"
                                        style="border-right: 1px solid;background-color: none !important;">
                                        <p class="per-month mb-1">Start Date</p>
                                        <h6 class="">{{datas.date_created|date:'yyyy-MM-dd'}}</h6>

                                    </div>
                                    <div class="col-6" style="border-radius: 20px;">
                                        <p class="per-month mb-1">End Date</p>
                                        <h6 class="">{{datas.event_start_date|date:'yyyy-MM-dd'}}</h6>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">

                                    <div class=" col-6"
                                        style="border-right: 1px solid;background-color: none !important;">
                                        <p class="per-month mb-1">Products</p>
                                        <h6 class="">{{datas.product}}</h6>

                                    </div>
                                    <div class="col-6" style="border-radius: 20px;">
                                        <p class="per-month mb-1">City</p>
                                        <h6 class="">{{datas.city}}</h6>
                                    </div>
                                </div>
                                <hr>
                                <div class="row">
                                    <div class="col-1"></div>
                                
                                    <div class="col-10" style="border-radius: 20px;">
                                        <p class="per-month">Suburb: 
                                            <span class="per-month "
                                                [ngClass]="{'clickable': overflowStatuses1[i]}"
                                                (click)="openDialog(datas.suburb, 'suburb', i)" 
                                                #Suburb
                                                style="max-width: 100%;">
                                                <b>{{datas.suburb || '--'}}</b>
                                            </span>
                                        </p>
                                    </div>
                                
                                    <div class="col-1"></div>
                                </div>
                                
                                <div class="col-md-12 d-flex align-items-center justify-content-center mt-1">
                                    <button type="button" class="btn btn-primary" (click)="view(datas.id)">
                                        <i class="fa fa-eye"></i> View
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
</div>
<button *ngIf="showScrollToTopButton" class="scroll-to-top-button" (click)="scrollToTop()"
    aria-label="Scroll to top">
    <i class="fas fa-arrow-up"></i> 
</button>